import React, { useState } from 'react';
import { Layers, Calendar, Bus, ShieldCheck, CheckCircle2 } from 'lucide-react';

export const SchoolERPModule: React.FC = () => {
  const [selectedRoute, setSelectedRoute] = useState('Route #4 (East Zone Wheelchair Van)');
  const [wheelchairRampActive, setWheelchairRampActive] = useState(true);
  const [generatedMsg, setGeneratedMsg] = useState('');

  const handleGenerateTimetable = () => {
    setGeneratedMsg('Adaptive timetable synchronized with classroom assistant shifts!');
    setTimeout(() => setGeneratedMsg(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-cyan-100 text-cyan-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Enterprise Special Education ERP
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Special School ERP & Timetable Engine</h2>
          <p className="text-xs text-slate-500">Adaptive scheduling, wheelchair bus route GPS, and paraprofessional rosters</p>
        </div>

        <button 
          onClick={handleGenerateTimetable}
          className="px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <Calendar className="w-4 h-4" />
          <span>Auto-Generate Timetable</span>
        </button>
      </div>

      {generatedMsg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {generatedMsg}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <Bus className="w-4 h-4 text-cyan-600" />
            Wheelchair Bus Route GPS Tracking
          </h3>

          <div className="space-y-2">
            <label className="block text-xs font-bold text-slate-700">Select Active Bus Route</label>
            <select 
              value={selectedRoute}
              onChange={(e) => setSelectedRoute(e.target.value)}
              className="w-full px-3 py-2 border rounded-xl text-xs font-bold bg-white focus:ring-2 focus:ring-cyan-500"
            >
              <option value="Route #1 (North Suburbs - Standard Van)">Route #1 (North Suburbs - Standard Van)</option>
              <option value="Route #4 (East Zone Wheelchair Van)">Route #4 (East Zone Wheelchair Van)</option>
              <option value="Route #7 (South Zone Hydraulic Lift Bus)">Route #7 (South Zone Hydraulic Lift Bus)</option>
            </select>
          </div>

          <div className="p-3 bg-white border rounded-xl space-y-2 text-xs">
            <div className="flex justify-between font-bold text-slate-900">
              <span>Selected Route:</span>
              <span className="text-cyan-700">{selectedRoute}</span>
            </div>
            <div className="flex items-center gap-2">
              <input 
                type="checkbox" 
                checked={wheelchairRampActive}
                onChange={() => setWheelchairRampActive(!wheelchairRampActive)}
                className="rounded text-cyan-600 focus:ring-cyan-500" 
              />
              <span className="text-slate-700 font-bold">Hydraulic Ramp Sensor Online</span>
            </div>
          </div>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <ShieldCheck className="w-4 h-4 text-emerald-600" />
            Paraprofessional Staff Duty Roster
          </h3>

          <div className="space-y-2 text-xs">
            <div className="p-2.5 bg-white border rounded-xl flex justify-between items-center">
              <div>
                <div className="font-bold text-slate-900">Sarah Jenkins (SLP)</div>
                <div className="text-[10px] text-slate-500">Room 102 • 09:00 AM - 10:30 AM</div>
              </div>
              <span className="px-2 py-0.5 bg-emerald-100 text-emerald-800 text-[10px] font-bold rounded">Active</span>
            </div>
            <div className="p-2.5 bg-white border rounded-xl flex justify-between items-center">
              <div>
                <div className="font-bold text-slate-900">Michael Chen (OT)</div>
                <div className="text-[10px] text-slate-500">Sensory Lab • 10:45 AM - 12:15 PM</div>
              </div>
              <span className="px-2 py-0.5 bg-emerald-100 text-emerald-800 text-[10px] font-bold rounded">Active</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
